import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/OperationalExe/cloudSupport.jpg"

import { AiOutlineCloudServer } from "react-icons/ai";
import { GrResources } from "react-icons/gr";
import { BiNetworkChart } from "react-icons/bi";

export default function MainSection5() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div> 
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Cloud Operations
            </h1>
            <p className="text-lg text-gray-600">
            Cloud operations involve managing and optimizing multi-cloud and hybrid environments to ensure seamless performance across various cloud platforms.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineCloudServer className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Multi-Cloud Management</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Oversee operations across AWS, Azure, Alibaba Cloud, and GCP for flexible cloud infrastructure.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BiCoinStack className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Hybrid Environment Support</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Manage both on-premise and cloud resources to create a unified system.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <GrResources className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Resource Optimization</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Ensure efficient use of cloud resources across different platforms to reduce costs.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BiNetworkChart className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Seamless Integration</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Integrate and manage diverse cloud environments for consistent performance and scalability.
              </p>
            </div>
          </div>
        </div>

      
      </div>
    </div>
  )
}